export default {
  categoryTree: [
    {
      title: "Satılık",
      list: [
        {
          key: "Konut",
          slug: "/satilik-konut",
        },
        {
          key: "İşyeri",
          slug: "/satilik-isyeri",
        },
        {
          key: "Devren İşyeri",
          slug: "/devren-isyeri",
        },
        {
          key: "Arsa",
          slug: "/satilik-arsa",
        },
        {
          key: "Kat Karşılığı Arsa",
          slug: "/kat-karsiligi-arsa",
        },
        {
          key: "Turistik Tesis",
          slug: "/satilik-turistik-tesis",
        },
      ],
    },
    {
      title: "Kiralık",
      list: [
        {
          key: "Konut",
          slug: "/kiralik-konut",
        },
        {
          key: "Günlük Kiralık Konut",
          slug: "/gunluk-kiralik-konut",
        },
        {
          key: "İşyeri",
          slug: "/kiralik-isyeri",
        },
        {
          key: "Arsa",
          slug: "/kiralik-arsa",
        },
        {
          key: "Turistik Tesis",
          slug: "/kiralik-turistik-tesis",
        },
      ],
    },
    {
      title: "Proje",
      list: [
        {
          key: "Konut",
          slug: "/satilik-konut/projeler",
        },
        {
          key: "İşyeri",
          slug: "/satilik-isyeri/projeler",
        },
      ],
    },
  ],
};
